import { Fragment, Component } from 'react';
import cx from 'classnames';
import { CDN_CLRSAVE_URL, SUBTYPE_MAPPING } from '../../constants';
import styles from '../../styles/homePage/topFunds.scss';
import ReactTooltip from 'react-tooltip';
import { handleTrack } from '../../utils/trackActions';
import { truncate } from './../../utils/commonUtils';

interface Props {
  fundItem: any;
  width?: any;
  infoWidth?: number;
  valign?: string;
  className?: string;
  subTitleClass?: string;
  imageValign?: string;
  hideSubTitle?: boolean;
  source?: string;
  parentClass?: string;
  isImported?: boolean;
  isMerged?: boolean;
  handleMergePopup?: (e: any, isin: string, title: string) => void;
}

class FundAvatar extends Component<Props> {
  public handleClick = (e: any) => {
    const { fundItem, source } = this.props;
    const { fundMetaData, fundType } = fundItem;
    handleTrack({
      label: `top_funds_textLink_${source}_${fundType}`,
      obj: e.target,
    });
    if (fundMetaData) {
      e.stopPropagation();
    } else {
      e.preventDefault();
    }
  };

  private getFundTitle() {
    const { className, fundItem, source } = this.props;
    const { title, fundName, fundMetaData, planType = 'GROWTH' } = fundItem;
    let href = '';

    if (fundMetaData) {
      const { slug, parentSlug, isinCode } = fundMetaData;
      href = `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=${source}&planType=${planType}`;
    }

    return (
      <Fragment>
        <a
          data-tip={title || fundName}
          data-for="fund-title"
          onClick={this.handleClick}
          className={cx('font--black block text--md', className, styles.title)}
          href={href}
        >
          {title || fundName}
        </a>
        <ReactTooltip
          effect="solid"
          id="fund-title"
          type="dark"
          backgroundColor="black"
        />
      </Fragment>
    );
  }

  public render() {
    const {
      width,
      infoWidth,
      valign,
      fundItem,
      subTitleClass,
      imageValign,
      hideSubTitle,
      parentClass,
      isImported,
      isMerged,
      handleMergePopup,
    } = this.props;

    const { title, fundName, status, imageUrl, fundMetaData } = fundItem;

    return (
      <Fragment>
        <div
          className={cx(
            {
              [styles['avatar-parent']]: fundMetaData,
            },
            parentClass
          )}
        >
          <div className={cx(styles['image-box'], 'image-box')}>
            <img
              className=""
              src={`${CDN_CLRSAVE_URL}/clearsave${imageUrl}`}
              alt={title || fundName}
            />
          </div>
          <div className={cx(styles.info, 'info inline-block')}>
            {this.getFundTitle()}
            {!hideSubTitle && (
              <Fragment>
                <span
                  data-tip={fundItem.subTitle || getFundType(fundItem)}
                  data-for="fund-subtitle"
                  className={cx(
                    'font--grey inline',
                    subTitleClass,
                    styles.sub,
                    {
                      [`status--${(status || '').toLowerCase()}`]: status,
                    }
                  )}
                >
                  {truncate(fundItem.subTitle || getFundType(fundItem), 17)}
                </span>
                <ReactTooltip
                  effect="solid"
                  id="fund-subtitle"
                  type="dark"
                  backgroundColor="black"
                />
              </Fragment>
            )}
            {isMerged && (
              <span
                className="lil-text-s-10 lil-text-blue-300 lil-font-bold lil-ml-3 merge-btn"
                onClick={(e) =>
                  handleMergePopup(e, fundMetaData.isinCode, title)
                }
              >
                Merged
              </span>
            )}
            {isImported ? (
              <span className="lil-bg-grey-300 ml10 lil-text-s-12 imported-tag">
                Imported Fund
              </span>
            ) : null}
          </div>
        </div>
        <style jsx>{`
          .image-box {
            width: ${width || 10}%;
            min-width: 20px;
            vertical-align: ${imageValign || 'initial'};
          }

          .info {
            vertical-align: ${valign || 'super'};
            width: ${infoWidth || 75}%;
          }
          .imported-tag {
            padding: 2px 5px;
          }
          @media screen and (max-width: 768px) {
            .info {
              vertical-align: inherit;
            }
          }
        `}</style>
      </Fragment>
    );
  }
}

export default FundAvatar;

const getFundType = (fund) => {
  const { mutualFundSubType } = fund;
  if (mutualFundSubType && mutualFundSubType.name) {
    return SUBTYPE_MAPPING[mutualFundSubType.name];
  }

  return fund.fundType;
};



// WEBPACK FOOTER //
// ./components/common/fundAvatar.tsx